<script setup>
import {ref} from "vue";
import IconStoryCreate from "@/components/Icons/IconStoryCreate.vue";
import NewsPageStoryModal from "@/components/NewsPage/NewsPageRoof/NewsPageStory/NewsPageStoryModal.vue";
import { t } from "@/controllerLK/AvalLocalization";

// Отображение модального окна создания сюжетов.
const isShowModal = ref(false);

// Переключение отображение модального окна.
const toggleModal = () => isShowModal.value = !isShowModal.value;
</script>

<template>
  <!-- TODO: Disabled story-->
  <AvalButtonFixedPrimary
    v-if="0"
    class="create-story-button"
    size="large"
    @click="toggleModal"
  >
    <template #icon-left>
      <IconStoryCreate />
    </template>
    {{ t("news_page_story.button.create") }}
  </AvalButtonFixedPrimary>
  <NewsPageStoryModal
    v-if="isShowModal"
    :is-open="isShowModal"
    @close="toggleModal"
  />
</template>

<style scoped lang="scss">
.create-story-button {
  white-space: nowrap;
}
</style>